module.exports = "\n    <app-cameras-item></app-cameras-item>\n"